import React from 'react';
import AuthStatusCard from './AuthStatusCard';
import { useAuth } from './AuthProvider';

interface PlatformRouteProps {
  children: React.ReactElement;
  title?: string;
}

const PlatformRoute: React.FC<PlatformRouteProps> = ({
  children,
  title = 'Platform Access Required',
}) => {
  const { status, error, user, canAccessCommandCentre, refreshAuth } = useAuth();

  if (status === 'initializing') {
    return (
      <AuthStatusCard
        title="Checking platform access"
        message="Verifying your global Command Center session."
      />
    );
  }

  if (status === 'error') {
    return (
      <AuthStatusCard
        title="Unable to verify access"
        message={error || 'Command Centre could not verify your access.'}
        actionLabel="Try again"
        onAction={refreshAuth}
      />
    );
  }

  if (status !== 'authenticated' || !user) {
    return (
      <AuthStatusCard
        title="Administrator Access Required"
        message="Please sign in with your Elite Core platform administrator account."
      />
    );
  }

  if (!canAccessCommandCentre) {
    return (
      <AuthStatusCard
        title={title}
        message="This module is available only to Elite Core administrators approved for the current Command Centre rollout."
      />
    );
  }

  return children;
};

export default PlatformRoute;
